module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-bold-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-bold-webfont.woff2
// module id = 141
// module chunks = 3